export default __webpack_public_path__ + "static/media/Joe-Bass.ac926de5.jpg";